<template>
    <div v-if="consents.length > 0">
        <ProfileBlock :title="$t('components.consents_view.block_name')">
            <dl class="sm:divide-y">
                <div v-for="(option, key) in options" :key="key" class="py-4 flex items-center">
                    <span class="material-icons-outlined mr-1 text-green-500">check</span> {{ option.label }}
                </div>
                <div v-if="value.length === 0" class="text-center">
                    {{ $t("components.consents_view.empty") }}
                </div>
            </dl>

            <template v-slot:block-link>
                <router-link
                    tag="div"
                    :to="{ name: 'ManageConsents' }"
                    v-dr-permission="'drg.app.profile.consents.edit'"
                >
                    {{ $t("components.consents_view.manage_button") }}
                </router-link>
            </template>
        </ProfileBlock>
    </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import ProfileBlock from "@/components/profile/ProfileBlock";
export default {
    name: "ConsentsView",
    components: { ProfileBlock },
    methods: mapActions({ fetch: "profile/consents/fetch" }),
    computed: {
        value: {
            get() {
                return this.consents
                    .filter(consent => consent.is_granted)
                    .map(consent => consent.id);
            },
            set() {
                // we need this to prevent error in console
            }
        },
        options() {
            return this.consents
                .filter(consent => consent.is_granted)
                .map(consent => ({ value: consent.id, label: consent.body }));
        },
        ...mapGetters({
            consents: "profile/consents/consents"
        })
    },
    mounted() {
        this.fetch();
    }
};
</script>
